import { render, staticRenderFns } from "./AdditionalIncome.vue?vue&type=template&id=041242bc&"
import script from "./AdditionalIncome.vue?vue&type=script&lang=js&"
export * from "./AdditionalIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports